<template>
    <div class="art" >
        <img src="https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=ad9b562e0d2341cf834a4e0f6fa44153" alt="">
        <div class="artwrap">
            <div class="artCon">
                <p style="font-size: 26px;text-align: center;">
                    {{ basicTitle }}
                </p>
                <br>
                <div>
                    <span>
                        {{ createdDt }}
                    </span>
                </div>
                <br>
                <div style="text-align: left;" class="artConartCon" v-html="articleContent">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                articleContent: '',
                basicTitle: '',
                createdDt: '',
                basicDescription: '',
            }
        },
        components: {
        },
        created(){
            console.log(this.$route.query.art);
            console.log(this.$route.query.category);
            this.getArticleByCategoryIds();
        },
        methods: {
            getArticleByCategoryIds(){
                
                this.axios.post(this.appUtils.getSignWithUrl(this.apis.home.getArticleByCategoryIds+this.$route.query.category+'?appId=APPT047&currentPage=1&pageSize=10000'))
                .then((res)=>{
                    console.log(res);
                    for (var i of res.data.data){
                        if (i.articleBasicid == this.$route.query.art){
                            this.articleContent = i.articleContent;
                            this.basicTitle = i.basicTitle;
                            this.createdDt = i.createdDt;
                            this.basicDescription = i.basicDescription;
                        }
                    }
                }).catch((err)=> {
                    console.log(err);
                });
            },
        }
    }
</script>

<style lang="scss">
    .art > img{
        width: 100%;
    }
    .artwrap{
        background: #F1F8FE;
        padding: 20px 0;
        .artCon{
            width: 1200px;
            margin: auto;
            background: white;
            padding: 30px 50px;
            p{
                font-size: 16px;
                text-align: left;
                color: #333333;
                line-height: 37px;
            }
            span{
                font-size: 12px;
                text-align: center;
                color: #333333;
            }
            .artConartCon{
                border-top: 1px solid #E5E9EB;
                padding: 20px;
            }
        }
    }
</style>
